import { AllowedAction } from '@/modules/common/types/allowed-actions';
import { IntegrationServices } from '@/modules/common/types/integrations';

/**
 * Domain enum for project change types/sections
 */
export enum ProjectChangeType {
  Info = 'info',
  Billing = 'billing',
  Integration = 'integration',
}

/**
 * Domain model for a changed field
 */
export interface ProjectChangedField {
  field: string;
  fieldLocalizedName: string | null;
  from: string | null;
  to: string | null;
  subfieldChanges: ProjectChangedField[] | null;
  /** Indicates if this field represents a grouped collection (e.g., multiple USER_RATES entries) */
  isGrouped?: boolean;
  /** Count of items in the group (for display purposes) */
  groupCount?: number;
}

/**
 * Domain model for who changed the project
 */
export interface ProjectChangedBy {
  id: number;
  name: string;
  profileImageUrl: string | null;
  isIntegration: boolean;
  integrationProvider?: IntegrationServices;
}

/**
 * Domain model for project change log entry
 */
export interface ProjectChangeLogEntry {
  id: number;
  type: ProjectChangeType;
  startDate: string;
  endDate: string | null;
  changedBy: ProjectChangedBy;
  changedFields: ProjectChangedField[];
  allowedActions: AllowedAction[];
  isActive: boolean;
}
